var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        _vm.$style["mds-tooltip"],
        _vm.classObject,
        _vm.sizeClass,
        _vm.variationClass,
        _vm.positionClass,
      ],
      attrs: {
        role: "tooltip",
        "aria-hidden": !_vm.isVisible,
        "data-mds-version": _vm.version,
      },
    },
    [
      _vm._t("default", function () {
        return [_vm._v(_vm._s(_vm.text))]
      }),
      _vm._v(" "),
      _vm.variation === "prompt"
        ? _c(
            "div",
            { class: _vm.$style["mds-tooltip__close-button"] },
            [
              _c("mds-button", {
                attrs: {
                  type: "button",
                  variation: "icon-only",
                  size: "small",
                  icon: "remove",
                  text: _vm.dismissIconAriaLabel,
                  onDark: "",
                },
                on: { click: _vm.hide },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }